import React from "react";
import { Card } from "antd";

type CardProps = {
  cardTitle?: string | React.ReactNode;
  cardProps?: any;
  children: React.ReactNode;
};

const WrappedCard = ({ cardTitle, cardProps, children }: CardProps) => {
  return (
    <Card
      {...(cardTitle && {
        title: (
          <div style={{ display: "flex", whiteSpace: "pre-wrap" }}>
            {cardTitle}
          </div>
        )
      })}
      {...cardProps}
    >
      {children}
    </Card>
  );
};

export default WrappedCard;
